import React from "react";

import { inject, observer } from "mobx-react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faCrown, faClone } from "@fortawesome/free-solid-svg-icons";

import { PermissionsController } from "../../PermissionsController";
import { Skeleton, Empty, Button, Tooltip } from "antd";
import { AppStore } from "~/stores/AppStore";
import _ from "lodash";
//import { awesomeIcon } from "~/utils/helpers";

@inject("permissionsController", "store")
@observer
export class Permissions extends React.Component<{
  permissionsController?: PermissionsController;
  store?: AppStore;
}> {
  private renderUserRoles = () => {
    const { userRolesData, exportRolePermissions, resyncRoles, selectedUserRole, handleUserRoleSelection, resyncModeEnabled } = this.props.permissionsController;

    const elements = [];
    const user = this.props.store.user;
    const userRole = _.get(user, "roles", []).length > 0 && _.get(user, "roles[0]", "");

    userRolesData.forEach((ur) => {
      elements.push(
        <div
          className={selectedUserRole && selectedUserRole._id === ur._id ? "rolesRow selected" : "rolesRow"}
          key={ur._id}
          onClick={(e: any) => {
            // If the buttons pressed within container, ignore selection
            if (e.target.nodeName === "DIV") {
              handleUserRoleSelection(ur._id);
            }
          }}
        >
          <div className="flex flex-1 ml-3 items-center">
            <span>{ur.name}</span>
            {userRole === ur.roleRef && (
              <Tooltip placement="right" title="Your User's Role" arrowPointAtCenter={true}>
                {/* <Icon type="crown" style={{ color: "#dd9f2d", fontSize: 17, marginLeft: 5 }} /> */}
                <FontAwesomeIcon icon={faCrown} className="ml-4 text-yellow-500" />
              </Tooltip>
            )}
          </div>

          {resyncModeEnabled && (
            <Tooltip placement="top" title={ur.mismatchedData ? "Resync Roles Data" : "Data Synced"} arrowPointAtCenter={true}>
              <Button style={{ marginRight: 5 }} size="small" icon={ur.mismatchedData ? "sync" : "check"} className="permissionOption" onClick={() => resyncRoles(ur)} disabled={!ur.mismatchedData} />
            </Tooltip>
          )}

          <Tooltip placement="top" title="Clone Roles Permissions" arrowPointAtCenter={true}>
            <Button
              style={{ marginRight: 5 }}
              size="small"
              className="permissionOption flex items-center"
              icon={<FontAwesomeIcon icon={faClone} />}
              onClick={() => {
                this.props.permissionsController.permissionCloning.visible = true;
                this.props.permissionsController.permissionCloning.cloningFrom = ur;
              }}
              disabled={true}
            />
          </Tooltip>

          {/* <Tooltip placement="top" title="Export role" arrowPointAtCenter={true}>
            <Button size="small" icon={<FontAwesomeIcon icon={faDownload} />} className="permissionOption mr-3" onClick={() => exportRolePermissions([ur], "Exported Roles For " + ur.name)} />
          </Tooltip> */}
        </div>
      );
    });

    return <div className="rolesPanel">{elements}</div>;
  };

  public render() {
    const { fetchingRoles, userRolesData } = this.props.permissionsController;

    if (fetchingRoles) {
      return <Skeleton key="loading" active={true} title={false} paragraph={{ rows: Math.ceil((window.innerHeight - 124) / 32), width: "100%" }} />;
    }

    if (userRolesData.length === 0) {
      return <Empty key="empty" image={Empty.PRESENTED_IMAGE_SIMPLE} description="No user roles loaded" />;
    }

    return this.renderUserRoles();
  }
}
